import { render, staticRenderFns } from "./AdTemplate.vue?vue&type=template&id=38d11fd5"
import script from "./AdTemplate.vue?vue&type=script&lang=ts"
export * from "./AdTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports